<template>
    <v-container fluid>
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    { text: 'Growth Tasks', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer />
            <v-btn-toggle
                v-model="toggleGrowthTaskScope"
                class="mr-6"
                dense
                mandatory
                rounded
            >
                <v-btn small active-class="pink--text"
                    >Action<v-chip
                        x-small
                        class="ml-1 pa-1"
                        color="red"
                        text-color="white"
                        v-if="growthTaskActionsCount > 0"
                        >{{ growthTaskActionsCount }}</v-chip
                    ></v-btn
                >
                <v-btn small active-class="orange--text"
                    >Ready For Sale<v-chip
                        x-small
                        class="ml-1 pa-1"
                        color="red"
                        text-color="white"
                        v-if="growthTaskReadyToSellOverdueCount"
                    >
                        {{ growthTaskReadyToSellOverdueCount }}</v-chip
                    ></v-btn
                >
                <v-btn small active-class="success--text">Open</v-btn>
                <v-btn small>Closed</v-btn>
                <v-btn small>All</v-btn>
            </v-btn-toggle>
        </v-row>

        <!-- Add growth task dialog -->
        <GrowthTaskEditDialog
            :dialog.sync="growthTaskEditDialog"
            v-on:item-created="onGrowthTaskCreated"
        ></GrowthTaskEditDialog>

        <!-- Update Growth task Plan -->
        <UpdateTask
            ref="UpdateTaskDialogRef"
            :updateTaskPlanDialog="updateTaskPlanDialog"
            v-on:plsCloseUpdateTaskPlanDialog="closeUpdateTaskPlanDialog"
        ></UpdateTask>

        <!-- GrowthTask Dialog -->
        <v-dialog v-model="growthTaskDialog" scrollable>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="closeGrowthTaskDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title
                        >Growth Task ID{{
                            selectedGrowthTaskRawId
                        }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="goToGrowthTaskDetail(selectedGrowthTaskNodeId)"
                    >
                        <v-icon>launch</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mx-0 px-0">
                    <GrowthTaskDetailComponent
                        v-if="selectedGrowthTaskNodeId"
                        :growthTaskNodeId="selectedGrowthTaskNodeId"
                        v-on:growthTask-items-updated="refreshCurrentPage"
                        v-on:item-deleted="onGrowthTaskDeleted"
                    ></GrowthTaskDetailComponent>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Delete Task Dialog -->
        <!-- <DeleteDialog
            :dialog.sync="deleteTaskDialog"
            :item="deletingGrowthTask"
            v-on:confirmed="deleteTaskConfirmed"
        >
            <template v-slot:title>Delete Task</template>
            <template v-slot:content>Are you sure you want to delete this task?</template>
        </DeleteDialog>-->

        <v-row>
            <!-- Task table -->
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-title class="pb-0">
                                <v-col sm="12" md="3">
                                    <v-icon color="primary" class="mx-2"
                                        >date_range</v-icon
                                    >Growth Tasks
                                    <v-btn
                                        v-if="hasPermission('view_growthtask')"
                                        icon
                                        fab
                                        small
                                        class="mr-5"
                                        @click="goToGrowthTaskSettings()"
                                    >
                                        <v-icon>settings</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-spacer></v-spacer>

                                <v-col
                                    cols="6"
                                    sm="2"
                                    md="2"
                                    align-self="start"
                                >
                                    <v-autocomplete
                                        v-model="selectedPlanListPotSizeId"
                                        :items="tenantPotSizes.edges"
                                        item-value="node.id"
                                        item-text="node.potSizeCm"
                                        :disabled="
                                            $apollo.queries.tenantPotSizes
                                                .loading
                                        "
                                        label="Pot Size (cm)"
                                        dense
                                        clearable
                                        hide-details
                                    >
                                    </v-autocomplete
                                ></v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-row justify="end" align="end">
                                        <v-text-field
                                            dense
                                            v-model="search"
                                            append-outer-icon="refresh"
                                            @click:append-outer="
                                                refreshCurrentPage()
                                            "
                                            label="Search"
                                            clearable
                                            hide-details
                                            class="mx-2"
                                            @keydown.enter="
                                                refreshCurrentPage()
                                            "
                                            @click:clear="onClearSearch()"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                                <v-spacer />
                                <v-btn
                                    v-if="toggleGrowthTaskScope == 0"
                                    color="primary"
                                    outlined
                                    rounded
                                    small
                                    href="#/GrowthTaskPhases"
                                    >All Actions</v-btn
                                >
                                <v-btn
                                    v-if="hasPermission('add_growthtask')"
                                    color="primary"
                                    dark
                                    outlined
                                    rounded
                                    small
                                    class="mx-2"
                                    @click="growthTaskEditDialog = true"
                                    >New Task</v-btn
                                >
                                <vue-excel-xlsx
                                    :fetch="userRequestExcel"
                                    :columns="columns"
                                    :file-name="'GrowthTaskExport'"
                                    :file-type="'xlsx'"
                                    :sheet-name="'sheetname'"
                                >
                                    <v-btn
                                        small
                                        outlined
                                        color="primary"
                                        rounded
                                        class="mr-2 mb-1"
                                        dense
                                        :disabled="
                                            tenantGrowthTasks &&
                                            tenantGrowthTasks.edges &&
                                            tenantGrowthTasks.edges.length > 0
                                                ? false
                                                : true
                                        "
                                        :loading="isExportingGrowthTasks"
                                    >
                                        Download
                                    </v-btn>
                                </vue-excel-xlsx>
                            </v-card-title>
                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries.tenantGrowthTasks
                                            .loading
                                    "
                                    :items="tenantGrowthTasks.edges"
                                    :options.sync="dataTableOptions"
                                    loading-text="Loading... Please wait"
                                    :server-items-length="
                                        tenantGrowthTasks.totalCount
                                    "
                                    :items-per-page="defaultItemsPerPage"
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ],
                                        'disable-pagination':
                                            $apollo.queries.tenantGrowthTasks
                                                .loading
                                    }"
                                >
                                    <template v-slot:item.warning="{ item }">
                                        <v-icon
                                            v-if="
                                                !item.node.isReadyToSell &&
                                                    calculateDaysBetweenDays(
                                                        item.node
                                                            .currentGrowthTaskPhase
                                                            .endDate,
                                                        today
                                                    ) < 0
                                            "
                                            class="error--text"
                                            >warning</v-icon
                                        >
                                        <v-icon
                                            v-if="
                                                item.node.isReadyToSell &&
                                                    item.node.salesEndDate <
                                                        today
                                            "
                                            class="error--text"
                                            >warning</v-icon
                                        >
                                    </template>
                                    <template
                                        v-slot:item.departement="{ item }"
                                    >
                                        <span
                                            v-if="
                                                item.node.currentGrowthTaskPhase
                                            "
                                            >{{
                                                item.node.currentGrowthTaskPhase
                                                    .greenhouseDepartmentSection
                                                    .greenhouseDepartment
                                                    .greenhouse.name
                                            }}
                                            -
                                            {{
                                                item.node.currentGrowthTaskPhase
                                                    .greenhouseDepartmentSection
                                                    .greenhouseDepartment.name
                                            }}
                                            -
                                            {{
                                                item.node.currentGrowthTaskPhase
                                                    .greenhouseDepartmentSection
                                                    .name
                                            }}</span
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.potSize.potSizeCm="{
                                            item
                                        }"
                                    >
                                        <span
                                            >{{
                                                item.node.potSize.potSizeCm
                                            }}
                                            cm</span
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.totalInventory="{
                                            item
                                        }"
                                    >
                                        <span
                                            >{{ item.node.totalInventory }}
                                        </span>
                                        <v-tooltip
                                            top
                                            v-if="item.node.lockedForCustomer"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                    small
                                                    color="error"
                                                    v-on="on"
                                                    >lock</v-icon
                                                >
                                            </template>
                                            <span>{{
                                                item.node.lockedForCustomer.name
                                            }}</span>
                                        </v-tooltip>
                                    </template>
                                    <template
                                        v-slot:item.node.salesStartDate="{
                                            item
                                        }"
                                    >
                                        <v-chip
                                            small
                                            dark
                                            color="grey"
                                            v-if="item.node.totalInventory <= 0"
                                            >Closed</v-chip
                                        >
                                        <v-chip
                                            small
                                            color="orange"
                                            dark
                                            v-else-if="
                                                item.node.isReadyToSell &&
                                                    item.node.salesEndDate <
                                                        today
                                            "
                                            >Sales ({{
                                                calculateDaysBetweenDays(
                                                    today,
                                                    item.node.salesEndDate
                                                )
                                            }}
                                            days over)<v-icon small right
                                                >warning</v-icon
                                            ></v-chip
                                        >
                                        <v-chip
                                            small
                                            color="orange"
                                            dark
                                            v-else-if="
                                                item.node.isReadyToSell &&
                                                    item.node.salesStartDate <=
                                                        today
                                            "
                                            >Sales ({{
                                                calculateDaysBetweenDays(
                                                    item.node.salesEndDate,
                                                    today
                                                )
                                            }}
                                            days left)</v-chip
                                        >
                                        <v-chip
                                            small
                                            color="blue"
                                            dark
                                            v-else-if="
                                                item.node.growthStartDate >
                                                    today
                                            "
                                            >Planned ({{
                                                calculateDaysBetweenDays(
                                                    item.node.growthStartDate,
                                                    today
                                                )
                                            }}
                                            days left)</v-chip
                                        >
                                        <v-chip
                                            small
                                            color="success"
                                            dark
                                            v-else-if="
                                                today > item.node.growthEndDate
                                            "
                                            >Growing ({{
                                                calculateDaysBetweenDays(
                                                    today,
                                                    item.node.growthEndDate
                                                ) - 1
                                            }}
                                            days over)
                                            <v-icon small right
                                                >warning</v-icon
                                            ></v-chip
                                        >
                                        <v-chip
                                            small
                                            color="success"
                                            dark
                                            v-else
                                            >Growing ({{
                                                calculateDaysBetweenDays(
                                                    item.node.growthEndDate,
                                                    today
                                                ) + 1
                                            }}
                                            days left)</v-chip
                                        >
                                    </template>

                                    <template
                                        v-slot:item.node.createdAt="{ item }"
                                    >
                                        <span>{{
                                            item.node.createdAt
                                                | moment("YYYY-MM-DD")
                                        }}</span>
                                    </template>
                                    <template
                                        v-slot:item.node.growthStartDate="{
                                            item
                                        }"
                                    >
                                        <span>{{
                                            item.node.growthStartDate
                                                | moment("YYYY-MM-DD ([W]WW)")
                                        }}</span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <!-- <v-btn
                                            outlined
                                            rounded
                                            small
                                            color="primary"
                                            @click="goToGrowthTaskDetail(item.node)"
                                        >View</v-btn>-->
                                        <v-btn
                                            icon
                                            small
                                            color="primary"
                                            @click="
                                                openGrowthTaskDialog(item.node)
                                            "
                                        >
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                        <v-btn
                                            icon
                                            small
                                            color="primary"
                                            @click="
                                                openUpdateTaskPlanDialog(
                                                    item.node.id
                                                )
                                            "
                                        >
                                            <v-icon>event</v-icon>
                                        </v-btn>
                                        <v-btn
                                            icon
                                            small
                                            color="primary"
                                            @click="
                                                goToGrowthTaskDetail(
                                                    item.node.id
                                                )
                                            "
                                        >
                                            <v-icon>launch</v-icon>
                                        </v-btn>
                                        <!-- <v-icon small @click="onDeletingTask(item.node)">delete</v-icon> -->
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import GrowthTaskEditDialog from "@/components/growth/GrowthTaskEditDialog.vue";
import GrowthTaskDetailComponent from "@/components/growth/GrowthTaskDetailComponent.vue";
import UpdateTask from "@/components/growth/UpdateTask.vue";
import moment from "moment";

export default {
    name: "growth-task-list",
    components: {
        GrowthTaskEditDialog,
        GrowthTaskDetailComponent,
        UpdateTask
    },

    apollo: {
        growthTaskReadyToSellOverdueCount: {
            query: gql`
                query growthTaskReadyToSellOverdueCount(
                    $isReadyToSell: Boolean
                    $salesEndDateLte: Date
                    $totalInventoryGt: Int
                ) {
                    tenantGrowthTasks(
                        isReadyToSell: $isReadyToSell
                        salesEndDate_Lte: $salesEndDateLte
                        totalInventory_Gt: $totalInventoryGt
                    ) {
                        totalCount
                    }
                }
            `,
            variables() {
                return {
                    totalInventoryGt: 0,
                    isReadyToSell: true,
                    salesEndDateLte: this.today
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantGrowthTasks.totalCount,
            skip: false
        },
        growthTaskActionsCount: {
            query: gql`
                query growthTaskActionsCount(
                    $totalInventory_Gt: Int
                    $isReadyToSell: Boolean
                    $currentGrowthTaskPhase_EndDate_Lt: Date
                ) {
                    tenantGrowthTasks(
                        totalInventory_Gt: $totalInventory_Gt
                        isReadyToSell: $isReadyToSell
                        currentGrowthTaskPhase_EndDate_Lt: $currentGrowthTaskPhase_EndDate_Lt
                    ) {
                        totalCount
                    }
                }
            `,
            variables() {
                return {
                    totalInventory_Gt: 0,
                    isReadyToSell: false,
                    currentGrowthTaskPhase_EndDate_Lt: this.today
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantGrowthTasks.totalCount,
            skip: false,
            pollInterval: 60000 // ms
        },
        tenantPotSizes: {
            query: gql`
                query tenantPotSizes {
                    tenantPotSizes(orderBy: "potSizeCm") {
                        edges {
                            node {
                                id
                                potSizeCm
                            }
                        }
                    }
                }
            `,
            variables() {
                return {};
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => {
                return data.tenantPotSizes;
            },
            skip: false
        },
        tenantGrowthTasks: {
            query: gql`
                query tenantGrowthTasks(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $orderBy: String
                    $potSize_Id: ID
                    $search: String
                    $totalInventory_Gt: Int
                    $totalInventory_Lte: Int
                    $isReadyToSell: Boolean
                    $currentGrowthTaskPhase_EndDate_Lt: Date
                ) {
                    tenantGrowthTasks(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        potSize_Id: $potSize_Id
                        search: $search
                        orderBy: $orderBy
                        totalInventory_Gt: $totalInventory_Gt
                        totalInventory_Lte: $totalInventory_Lte
                        isReadyToSell: $isReadyToSell
                        currentGrowthTaskPhase_EndDate_Lt: $currentGrowthTaskPhase_EndDate_Lt
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                rawId
                                createdAt
                                growthStartDate
                                growthEndDate
                                salesStartDate
                                salesEndDate
                                isReadyToSell
                                note
                                plant {
                                    id
                                    name
                                    plantSpecies {
                                        id
                                        name
                                    }
                                }
                                potSize {
                                    id
                                    potSizeCm
                                }
                                color {
                                    id
                                    color
                                }
                                environment {
                                    id
                                    environment
                                }
                                tag {
                                    id
                                    tag
                                }
                                lockedForCustomer {
                                    id
                                    name
                                }
                                totalInventory
                                currentGrowthTaskPhase {
                                    id
                                    endDate
                                    greenhouseDepartmentSection {
                                        id
                                        name
                                        greenhouseDepartment {
                                            id
                                            name
                                            greenhouse {
                                                id
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantGrowthTasks,
            skip: true,
            pollInterval: 300000 // ms 5min
        }
    },

    data() {
        return {
            deleteTaskDialog: false,
            growthTaskEditDialog: false,
            growthTaskDialog: false,
            updateTaskPlanDialog: false,
            isLoadingGrowthTasks: false,

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,
            isExportingGrowthTasks: false,

            growthTaskActionsCount: 0,
            growthTaskReadyToSellOverdueCount: 0,
            shouldResetDataTablePage: false,
            tenantGrowthTasks: {},
            tenantPotSizes: {},

            selectedGrowthTaskNodeId: null,
            selectedGrowthTaskRawId: null,
            selectedPlanListPotSizeId: null,

            search: "",
            toggleGrowthTaskScope: 0,

            deletingGrowthTask: null,
            filteredGrowthTasks: [],
            greenhouseDepartments: [],
            selectedDepartments: [],
            dates: [],
            columns: [
                {
                    label: "ID",
                    field: "node.rawId"
                },
                {
                    label: "Greenhouse",
                    field:
                        "node.currentGrowthTaskPhase.greenhouseDepartmentSection.greenhouseDepartment.greenhouse.name"
                },
                {
                    label: "Section",
                    field:
                        "node.currentGrowthTaskPhase.greenhouseDepartmentSection.name"
                },
                {
                    label: "Department",
                    field:
                        "node.currentGrowthTaskPhase.greenhouseDepartmentSection.greenhouseDepartment.name"
                },
                {
                    label: "Plant Species",
                    field: "node.plant.plantSpecies.name"
                },
                {
                    label: "Plant",
                    field: "node.plant.name"
                },
                {
                    label: "Start Date",
                    field: "node.growthStartDate"
                },
                {
                    label: "Note",
                    field: "node.note"
                },
                {
                    label: "Pot Size",
                    field: "node.potSize.potSizeCm"
                },
                {
                    label: "Tag",
                    field: "node.tag"
                },
                {
                    label: "Inventory",
                    field: "node.totalInventory"
                }
            ],

            headers: [
                {
                    text: "",
                    value: "warning",
                    width: "40px",
                    sortable: false
                },
                {
                    text: "ID",
                    value: "node.rawId",
                    sortable: true
                },
                {
                    text: "Department",
                    value: "departement",
                    sortable: true
                },
                {
                    text: "Plant Species",
                    value: "node.plant.plantSpecies.name",
                    sortable: true
                },
                {
                    text: "Plant",
                    value: "node.plant.name",
                    sortable: true
                },
                {
                    text: "Start Date",
                    value: "node.growthStartDate",
                    sortable: true
                },
                {
                    text: "Note",
                    value: "node.note",
                    sortable: true
                },
                {
                    text: "Pot Size",
                    value: "node.potSize.potSizeCm",
                    sortable: true
                },
                {
                    text: "Color",
                    align: "left",
                    value: "node.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.tag.tag",
                    sortable: true
                },
                {
                    text: "Inventory",
                    value: "node.totalInventory",
                    sortable: true
                },
                {
                    text: "Status",
                    value: "node.salesStartDate",
                    sortable: false
                },
                // {
                //     text: "Created Date",
                //     value: "node.createdAt",
                //     sortable: true
                // },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        today() {
            var _now = new Date();
            return moment(_now).format("YYYY-MM-DD");
        }
    },
    watch: {
        selectedPlanListPotSizeId() {
            // this.shouldResetDataTablePage = true;
            this.$nextTick().then(() => {
                this.refreshCurrentPage();
            });
        },
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        },
        toggleGrowthTaskScope(value) {
            if (value != null) {
                localStorage.setItem("toggleGrowthTaskScope", value);

                this.refreshCurrentPage();
            }
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        // get tab of last visit from local
        if (localStorage.getItem("toggleGrowthTaskScope") != null) {
            this.toggleGrowthTaskScope = parseInt(
                localStorage.getItem("toggleGrowthTaskScope")
            );
        } else {
            this.toggleGrowthTaskScope = 0;
        }
    },
    methods: {
        openUpdateTaskPlanDialog(growthTaskUniqueId) {
            this.updateTaskPlanDialog = true;
            this.$nextTick(() => {
                this.$refs.UpdateTaskDialogRef.getGrowthTaskIdData(
                    growthTaskUniqueId
                );
            });
            // this.$refs.UpdateTaskDialogRef.getGrowthTaskIdData(
            //     growthTaskUniqueId
            // );
        },
        closeUpdateTaskPlanDialog() {
            this.updateTaskPlanDialog = false;
            /*this.growthTaskPhases = JSON.parse(
                JSON.stringify(this.growthTask.growthTaskPhaseSet.edges)
            );*/
        },
        async userRequestExcel() {
            this.isExportingGrowthTasks = true;

            const {
                sortBy,
                sortDesc
                //page,
                //itemsPerPage
            } = this.dataTableOptions;

            var _orderBy = null;
            var _totalInventory_Gt = null;
            var _totalInventory_Lte = null;
            var _isReadyToSell = null;
            var _currentGrowthTaskPhase_EndDate_Lt = null;

            switch (sortBy[0]) {
                case "node.rawId":
                    _orderBy = "id";
                    break;
                case "departement":
                    _orderBy = "greenhouseSectionName";
                    break;
                case "node.growthStartDate":
                    _orderBy = "growthStartDate";
                    break;
                case "node.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.color.color":
                    _orderBy = "color";
                    break;
                case "node.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.note":
                    _orderBy = "note";
                    break;
                case "node.totalInventory":
                    _orderBy = "totalInventory";
                    break;
                case "node.salesStartDate":
                    _orderBy = "salesStartDate";
                    break;
                case "node.createdAt":
                    _orderBy = "createdAt";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            //// filter tab

            // action
            if (this.toggleGrowthTaskScope === 0) {
                _totalInventory_Gt = 0;
                _isReadyToSell = false;
                _currentGrowthTaskPhase_EndDate_Lt = moment(new Date()).format(
                    "YYYY-MM-DD"
                );

                // refresh #actions
                this.$apollo.queries.growthTaskActionsCount.refresh();
            }

            // ready for sale
            if (this.toggleGrowthTaskScope === 1) {
                _totalInventory_Gt = 0;
                _isReadyToSell = true;
            }

            // open
            if (this.toggleGrowthTaskScope === 2) {
                _totalInventory_Gt = 0;
            }

            // closed
            if (this.toggleGrowthTaskScope === 3) {
                _totalInventory_Lte = 0;
            }
            const result = this.$apollo
                .query({
                    // Query
                    query: gql`
                        query tenantGrowthTasks(
                            $first: Int
                            $last: Int
                            $before: String
                            $after: String
                            $orderBy: String
                            $potSize_Id: ID
                            $search: String
                            $totalInventory_Gt: Int
                            $totalInventory_Lte: Int
                            $isReadyToSell: Boolean
                            $currentGrowthTaskPhase_EndDate_Lt: Date
                        ) {
                            tenantGrowthTasks(
                                first: $first
                                last: $last
                                before: $before
                                after: $after
                                potSize_Id: $potSize_Id
                                search: $search
                                orderBy: $orderBy
                                totalInventory_Gt: $totalInventory_Gt
                                totalInventory_Lte: $totalInventory_Lte
                                isReadyToSell: $isReadyToSell
                                currentGrowthTaskPhase_EndDate_Lt: $currentGrowthTaskPhase_EndDate_Lt
                            ) {
                                edges {
                                    node {
                                        id
                                        rawId
                                        createdAt
                                        growthStartDate
                                        growthEndDate
                                        salesStartDate
                                        salesEndDate
                                        isReadyToSell
                                        note
                                        plant {
                                            id
                                            name
                                            plantSpecies {
                                                id
                                                name
                                            }
                                        }
                                        potSize {
                                            id
                                            potSizeCm
                                        }
                                        color {
                                            id
                                            color
                                        }
                                        environment {
                                            id
                                            environment
                                        }
                                        tag {
                                            id
                                            tag
                                        }
                                        lockedForCustomer {
                                            id
                                            name
                                        }
                                        totalInventory
                                        currentGrowthTaskPhase {
                                            id
                                            endDate
                                            greenhouseDepartmentSection {
                                                id
                                                name
                                                greenhouseDepartment {
                                                    id
                                                    name
                                                    greenhouse {
                                                        id
                                                        name
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    variables: {
                        first: 1000,
                        last: null,
                        before: null,
                        after: null,
                        orderBy: _orderBy,
                        potSize_Id: this.selectedPlanListPotSizeId,
                        search: this.search,
                        totalInventory_Gt: _totalInventory_Gt,
                        totalInventory_Lte: _totalInventory_Lte,
                        isReadyToSell: _isReadyToSell,
                        currentGrowthTaskPhase_EndDate_Lt: _currentGrowthTaskPhase_EndDate_Lt
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    return response.data.tenantGrowthTasks.edges;
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isExportingGrowthTasks = false;
                });

            return result;
        },
        onAddGrowthTaskConfirmed() {
            // this.fetchGrowthTasks();
        },
        calculateDaysBetweenDays(day1, day2) {
            return moment(day1).diff(moment(day2), "day");
        },

        onClearSearch() {
            this.search = "";
            this.refreshCurrentPage();
        },

        refreshCurrentPage() {
            // reset data table page to first page
            if (this.shouldResetDataTablePage) {
                this.dataTableOptions.page = 1;
            }

            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            // console.log(this.dataTableOptions);

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;
            var _totalInventory_Gt = null;
            var _totalInventory_Lte = null;
            var _isReadyToSell = null;
            var _currentGrowthTaskPhase_EndDate_Lt = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantGrowthTasks.pageInfo.startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantGrowthTasks.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.rawId":
                    _orderBy = "id";
                    break;
                case "departement":
                    _orderBy = "greenhouseSectionName";
                    break;
                case "node.growthStartDate":
                    _orderBy = "growthStartDate";
                    break;
                case "node.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.color.color":
                    _orderBy = "color";
                    break;
                case "node.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.note":
                    _orderBy = "note";
                    break;
                case "node.totalInventory":
                    _orderBy = "totalInventory";
                    break;
                case "node.salesStartDate":
                    _orderBy = "salesStartDate";
                    break;
                case "node.createdAt":
                    _orderBy = "createdAt";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            //// filter tab

            // action
            if (this.toggleGrowthTaskScope === 0) {
                _totalInventory_Gt = 0;
                _isReadyToSell = false;
                _currentGrowthTaskPhase_EndDate_Lt = moment(new Date()).format(
                    "YYYY-MM-DD"
                );

                // refresh #actions
                this.$apollo.queries.growthTaskActionsCount.refresh();
            }

            // ready for sale
            if (this.toggleGrowthTaskScope === 1) {
                _totalInventory_Gt = 0;
                _isReadyToSell = true;
            }

            // open
            if (this.toggleGrowthTaskScope === 2) {
                _totalInventory_Gt = 0;
            }

            // closed
            if (this.toggleGrowthTaskScope === 3) {
                _totalInventory_Lte = 0;
            }

            this.$apollo.queries.tenantGrowthTasks.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                orderBy: _orderBy,
                potSize_Id: this.selectedPlanListPotSizeId,
                search: this.search,
                totalInventory_Gt: _totalInventory_Gt,
                totalInventory_Lte: _totalInventory_Lte,
                isReadyToSell: _isReadyToSell,
                currentGrowthTaskPhase_EndDate_Lt: _currentGrowthTaskPhase_EndDate_Lt
            });

            // set skip false to execute the query
            this.$apollo.queries.tenantGrowthTasks.skip = false;
            this.$apollo.queries.tenantGrowthTasks.refresh();

            // update this.page
            this.page = page;
            this.shouldResetDataTablePage = false;
        },

        openGrowthTaskDialog(growthTask) {
            this.selectedGrowthTaskNodeId = growthTask.id;
            this.selectedGrowthTaskRawId = growthTask.rawId;
            this.growthTaskDialog = true;
        },

        closeGrowthTaskDialog() {
            this.growthTaskDialog = false;
            this.selectedGrowthTaskNodeId = null;
            this.selectedGrowthTaskRawId = null;
            this.$apollo.queries.tenantGrowthTasks.refresh();
            // this.refreshCurrentPage();
        },

        onGrowthTaskCreated() {
            this.refreshCurrentPage();

            // this.goToGrowthTaskDetail(response.id);
        },

        onGrowthTaskDeleted() {
            // this.refreshCurrentPage();
            this.closeGrowthTaskDialog();
        },

        goToGrowthTaskDetail(growthTaskNodeId) {
            let routeData = this.$router.resolve({
                name: "growthtask-detail",
                params: { id: growthTaskNodeId }
            });
            window.open(routeData.href, "_blank");
        },

        goToGrowthTaskSettings() {
            this.$router.push({
                name: "growth-task-settings"
            });
        }

        // delete
        // onDeletingTask(growthTask) {
        //     this.deletingGrowthTask = growthTask;
        //     this.deleteTaskDialog = true;
        // },

        // deleteTaskConfirmed() {
        //     if (this.deletingGrowthTask) {
        //         const payload = {
        //             id: this.deletingGrowthTask.id
        //         };
        //         this.$store
        //             .dispatch("growthTasks/deleteGrowthTask", payload)
        //             .then(response => {
        //                 // close delete dialog
        //                 this.deleteTaskDialog = false;

        //                 this.$emit("taskDeleted", response);

        //                 this.fetchGrowthTasks();

        //                 // show snackbar
        //                 const payload = {
        //                     color: "success",
        //                     message: `The task is deleted!`
        //                 };
        //                 this.$store.dispatch("snackbar/showMessage", payload);
        //             })
        //             .catch(error => {
        //                 this.error = error.graphQLErrors[0].message;
        //             });
        //     }
        // }
    }
};
</script>
